import { FC, StrictMode } from 'react';
import { Notifications } from '@servicetitan/notifications';

import './design-system.css';
import './modules/common/styles/index.scss';
import '@progress/kendo-font-icons/dist/index.css';

import { AppWrapper } from './modules/common/components/app-wrapper';
import { LDServiceProvider } from '@servicetitan/launchdarkly-service';

export const App: FC = () => {
    return (
        <StrictMode>
            <LDServiceProvider>
                <Notifications>
                    <AppWrapper />
                </Notifications>
            </LDServiceProvider>
        </StrictMode>
    );
};
